/*
 * @Author: Teemo Ding
 * @Date: 2021-07-21 09:13:47
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-13 11:04:29
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelPayment/config.tsx
 */
import { Checkbox } from '@/src/components/Antd';
import { replaceI18nVariables } from '@/src/tools/tools';
// import { paymentGatewayProvider } from '@/src/types/common/paymentGateway';
import { get } from 'lodash';
import React from 'react';
import css from './css.module.less';

export const breadcrumbData = (
  salesChannelName,
  salesChannelUuid,
  { getI18n },
) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/salesChannels',
    name: getI18n('general.sider.salesChannel'),
  },
  {
    url: `/salesChannel/content/${salesChannelUuid}`,
    name: salesChannelName,
  },
  {
    url: `/salesChannel/settings/${salesChannelUuid}`,
    name: getI18n('general.sider.settings'),
  },
  {
    url: '',
    name: getI18n('salesChannelPayment.index.payment'),
  },
];

export const availableColumns = (
  deleteFun,
  editFun,
  isMini,
  showProcessingFee,
  disableEdit,
  { getI18n },
) => [
  {
    title: getI18n('salesChannelPayment.index.paymentGatewayName'),
    dataIndex: 'paymentGatewayName',
    key: 'paymentGatewayName',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 288,
  },
  {
    title: getI18n('salesChannelPayment.index.paymentProvider'),
    dataIndex: 'gatewayProviderName',
    key: 'gatewayProviderName',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 288,
  },
  {
    title: getI18n('salesChannelPayment.index.paymentMethod'),
    dataIndex: 'salesChannelPaymentMethods',
    key: 'salesChannelPaymentMethods',
    default: true,
    optional: false,
    className: `${isMini ? '' : css.paymentMethod} ${css.columnClass}`,
    minWidth: 224,
    render: (text, record) => {
      const salesChannelPaymentMethods =
        get(record, 'salesChannelPaymentMethods') || [];
      const activeMethod = salesChannelPaymentMethods.filter((i: any) => {
        return i.selected;
      });
      return activeMethod.map((item, index) => (
        <div key={index} className={css.paymentMethodItem}>
          {item?.paymentMethodVO?.name}
        </div>
      ));
    },
  },
  !!showProcessingFee && {
    title: getI18n('salesChannelPayment.index.processingFee'),
    default: true,
    optional: false,
    width: 160,
    className: css.columnClass,
    dataIndex: ['salesChannelPaymentMethods', 0, 'processingFee'],
    key: 'processingFee',
    render: (text) =>
      replaceI18nVariables(
        getI18n('salesChannelPayment.index.textofinvoicetotal'),
        text || 0,
      ),
  },
  disableEdit
    ? {}
    : {
        title: getI18n(
          'general.advancedFilters.commonStoreProductsWithTable.actions',
        ),
        dataIndex: 'action',
        key: 'action',
        default: true,
        optional: false,
        className: css.columnClass,
        width: 128,
        align: 'center',
        render: (text, record) => (
          <div className={css.action}>
            <span className={css.primary} onClick={() => editFun(record)}>
              {getI18n('general.edit')}
            </span>
            <span className={css.danger} onClick={() => deleteFun(record)}>
              {getI18n('general.delete')}
            </span>
          </div>
        ),
      },
];

export const currencyColumns = (deleteFun, disableEdit, { getI18n }) => [
  {
    title: getI18n('salesChannelPayment.index.currency'),
    dataIndex: 'label',
    key: 'label',
    default: true,
    optional: false,
    className: css.columnClass,
  },
  disableEdit
    ? {}
    : {
        title: getI18n(
          'general.advancedFilters.commonStoreProductsWithTable.actions',
        ),
        dataIndex: 'actions',
        key: 'actions',
        default: true,
        optional: false,
        className: css.columnClass,
        align: 'center',
        width: 128,
        render: (_, record) => (
          <span className={css.delete} onClick={() => deleteFun(record)}>
            {getI18n('general.delete')}
          </span>
        ),
      },
];

export const advancedColumns = (
  enableThirdPartyCurrency,
  primaryCurrency,
  currencyCodes,
  currencyCheck,
  showProcessingFee,
  disableEdit,
  { getI18n },
) => [
  {
    title: getI18n('salesChannelPayment.index.paymentMethod'),
    dataIndex: 'paymentMethodVO',
    key: 'paymentMethodVO',
    default: true,
    optional: false,
    className: `${css.paymentMethodItem} ${css.columnClass}`,
    width: 296,
    fixed: 'left',
    render: (text) => (
      <div>
        {text?.name || ''}
        {(text.icons || []).map((item, index) => (
          <img
            key={index}
            style={{ height: 20 }}
            src={item.url}
            className={css.paymentMethodItemImg}
          />
        ))}
      </div>
    ),
  },
  {
    title: getI18n('salesChannelPayment.index.paymentProvider'),
    dataIndex: 'gatewayProviderName',
    key: 'gatewayProviderName',
    default: true,
    optional: false,
    width: 256,
    className: css.columnClass,
  },
  {
    title: getI18n('salesChannelPayment.index.paymentGatewayName'),
    dataIndex: 'paymentGatewayName',
    key: 'paymentGatewayName',
    default: true,
    optional: false,
    width: 256,
    className: css.columnClass,
  },
  !!showProcessingFee && {
    title: getI18n('salesChannelPayment.index.processingFee'),
    default: true,
    optional: false,
    width: 170,
    className: css.columnClass,
    dataIndex: 'processingFee',
    key: 'processingFee',
    render: (text) =>
      replaceI18nVariables(
        getI18n('salesChannelPayment.index.textofinvoicetotal'),
        text || 0,
      ),
  },
  enableThirdPartyCurrency && {
    title: getI18n('salesChannelPayment.index.enableforChargeCurrency'),
    default: true,
    children: currencyCodes.map((item, index) => ({
      title: `${(item || {}).code} ${
        (item || {}).primaryCurrency
          ? `(${getI18n('salesChannelPayment.index.primaryCurrency')})`
          : ''
      }`,
      dataIndex: item.code,
      key: item.code,
      width: 192,
      default: true,
      render: (_, record) => {
        return (
          <Checkbox
            key={index}
            checked={
              record.chargeableCurrencyList.filter(
                (c) => c.currencyCode == item.code,
              )[0]?.enabled || false
            }
            disabled={disableEdit}
            onChange={() => currencyCheck(record, item.code)}></Checkbox>
        );
      },
    })),
  },
];

export const translateCurrencies = (
  currencies,
  currencyConversion,
  { getI18n },
) => {
  const codes = currencyConversion.map((currency) => (currency || {}).code);
  const currenciesFilter = currencies.filter((c) => !codes.includes(c.code));
  return currenciesFilter.map((currency) => ({
    ...currency,
    value: currency.code,
    labelText: `${currency.label} ${
      currency.reportingCurrency
        ? `- ${getI18n('salesChannelPayment.index.reportingcurrency')}`
        : ''
    }`,
  }));
};

export const translateGateways = (gateways, paymentGateway) => {
  // const haveBankTransfer = paymentGateway.some(
  //   (item) => item.gatewayProviderCode == paymentGatewayProvider.BANK_TRANSFER,
  // );
  const gatewaysFilter = gateways;
  // if (haveBankTransfer) {
  //   gatewaysFilter = gateways.filter(
  //     (item) =>
  //       item.gatewayProviderCode !== paymentGatewayProvider.BANK_TRANSFER,
  //   );
  // }
  const uuids = paymentGateway.map((item) => item.uuid);
  const gatewaysValid = gatewaysFilter.filter((o) => !uuids.includes(o.uuid));
  return gatewaysValid.map((gateway, index) => ({
    ...gateway,
    value: gateway.uuid,
    labelText: (
      <div key={index}>
        <div> {gateway.paymentGatewayName || ''}</div>
        <div className={css.gatewayProviderName}>
          {gateway.gatewayProviderName || ''}
          {(gateway.remarks && `|${gateway.remarks}`) || ''}
        </div>
      </div>
    ),
  }));
};
